//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useContext, useState } from 'react';

import { useTheme } from '@mui/material/styles';
import {
  Autocomplete,
  Box,
  Button,
  IconButton,
  TextField,
} from '@mui/material';
import { Search, ExpandMore, ExpandLess } from '@mui/icons-material';

// === COMPONENTS ===
import { Spacer } from 'components/Spacer';

// === HOOKS ===
import { useSession } from 'pages/PageManager/components/SessionContext';

// === UTILS ===
import { getHexAlpha } from 'components/styles.utils';

// === API ===
import { AssignUserModal } from '../AssignUserModal/index';

//#endregion

//-----------------------------------------------------------------
export function ControlBox(props) {
  //-----------------------------------------------------------------

  //#region [VALUES]
  
  const { user_details: user } = useSession();
  
  const theme = useTheme();

  const [ is_open_modal  , setIsOpenModal  ] = useState( false );
  const [ is_open_filter , setIsOpenFilter ] = useState( false );
  const [ is_open        , setIsOpen       ] = useState( true  );

  const has_selected = props.files ? Object.keys( props.files ).length > 0 : false;
  
  const expand_filter_icon = is_open_filter ? <ExpandLess /> : <ExpandMore />;
  const expand_icon        = is_open        ? <ExpandLess /> : <ExpandMore />;

  const _tags = [
    { label: 'My Files'    , group: 'Assigned User' , filter: (file) => file.assigned_user === user.Username , },
    { label: 'Other Files' , group: 'Assigned User' , filter: (file) => file.assigned_user !== user.Username , },
    { label: 'Complete'    , group: 'Status'        , filter: (file) => file.passed === true  , },
    { label: 'In Progress' , group: 'Status'        , filter: (file) => file.passed === false , },
  ];

  //#endregion

  //#region [STYLES]

  // === SX ===
  const _styles = {
    bar: {
      height       : 'max-content' ,
      width        : '100%'   ,
      overflow     : 'hidden' ,
      borderRadius : '1rem'   ,
      overflow     : 'hidden' ,
      padding      : '1rem'   ,
    },
    container_main: {
      width   : '100%'   ,
      display : 'flex'   ,
      margin  : '0.5rem' ,
    },
    header_text: {
      fontSize: 'x-large',
      paddingLeft: '1rem',
      paddingTop: '0.8rem',
      color : theme.palette.primary.contrastColor,
    },
    search_container: {
      display: is_open_filter ? 'flex' : 'none',
      // display: 'flex',
      margin: '0.5rem',
      marginTop : '1rem',
      justifyContent: 'center',
    },
    search_text: {
      width: '100%',
      maxWidth: '50rem',
    },
    assign_user_button: {
      width : '20rem',
      height: '3rem',
      whiteSpace: 'nowrap',
    },
    container_filter: {
      display: is_open_filter ? 'flex' : 'none',
      width: '100%',
      justifyContent: 'center',
    },
    filter_tags: {
      // height: '3rem',
      width: '100%',
      // padding: '0.5rem',
      // margin: '0.5rem',
    },
    header: {
      display: 'flex',
      fontSize: '2rem',
    },
  };

  // === ATTRIBUTES ===

  const HEADER = {
    style: _styles.header,
  };

  const
    CONTAINER = {
      style: _styles.bar,
    },
    TEXT_SEARCH = {
      sx: _styles.search_text,
      label: 'Search...',
      size : 'small', 
      onChange : onChangeSearch,
      name : 'da_file_list_search_input',
    },
    BUTTON_ASSIGN_USER = {
      sx       : _styles.assign_user_button,
      disabled : !has_selected,
      variant  : 'contained',
      color    : 'primary',
      onClick  : () => { setIsOpenModal(true) },
      children : ['Assign User'],
      name     : 'da_assign_user_btn',
    },
    BUTTON_EXPAND = {
      children: [expand_filter_icon],
      onClick: () => { setIsOpenFilter(!is_open_filter) },
      name    : 'da_filter_list_search_expand_btn',
    },
    BUTTON_HIDE = {
      children: [expand_icon],
      onClick: () => {
        setIsOpen(!is_open)
        if( props.onOpen ) props.onOpen(!is_open)
      },
      name    : 'da_hide_files_btn',
    },
    CONTAINER_FILTER = {
      style: _styles.container_filter,
    },
    FILTER_TAGS = {
      id          : 'filter-tags',
      sx          : _styles.filter_tags,
      multiple    : true,
      options     : _tags,
      groupBy     : (option) => option.group,
      renderInput : (params) => { return <TextField {...params} variant='standard' label="Filter Tags" /> },
      onChange    : (event, value) => { props.onFilter( value.map( x => x.filter ) ) },
      name        : 'da_filter_tags_select',
    };

  //#endregion

  //#region [EVENTS]

  //-----------------------------------------------------------------
  function onModalClose(event) {
    //-----------------------------------------------------------------
    try {
      setIsOpenModal(false)
    } catch (error) {
      console.warn(error);
    }
  }

  //-----------------------------------------------------------------
  function onChangeSearch(event) {
    //-----------------------------------------------------------------
    try {
      const search = event.target.value;
      props.onSearch( search?.toUpperCase() )
    } catch (error) {
      console.warn(error);
    }
  }

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <div { ...CONTAINER }>
        <AssignUserModal is_open={is_open_modal} files={props.files} onClose={onModalClose} />
        <div { ...HEADER }>
          <div style={{width: '20rem'}}>Files:</div>
          <Spacer fill />
          <IconButton> <Search /> </IconButton>
          <TextField  { ...TEXT_SEARCH        }/>
          <Spacer />
          <IconButton { ...BUTTON_EXPAND      } />
          <Spacer fill />
          <Button     { ...BUTTON_ASSIGN_USER } />
          <Spacer />
          <IconButton { ...BUTTON_HIDE        } />
        </div>
        <div { ...CONTAINER_FILTER }>
          <Spacer fill />
          <Autocomplete { ...FILTER_TAGS }/>
          <Spacer fill />
        </div>
      </div>
    );
  }

  //#endregion

  return display();
}